import { useNavigate } from 'react-router-dom';
import Button from '../../atoms/button/button';
import Table from '../../atoms/table/table';
import { CommissionsSearch } from '../../../models/commission.model';
import { Icon } from '../../atoms/icon';
import { EDIT_COMMISSION_PERMISSION, isAuthorizedToHandleCapability } from '../../../utils/capability-utils';
import { useAppDispatch, useAppSelector } from '../../../reducers';
import { openModal } from '../../../reducers/modal.reducer';
import { EditCommissionNameModal } from './commissionModals/editCommissionNameModal';

type Props = {
  commission: CommissionsSearch;
};

export const CommissionCard = (props: Props) => {
  const { commission } = props;
  const { user } = useAppSelector(state => state.authentication);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const commissionRelationsHandled = (commissionId: number) => {
    navigate(`/commissions/${commissionId}`);
  };

  const openEditCommissionNameModal = () => {
    dispatch(
      openModal({
        children: <EditCommissionNameModal commission={commission} />,
        opt: {
          size: 'xs',
          type: 'default',
          title: 'Modifica nome',
        },
      })
    );
  };

  return (
    <Table.Row>
      <Table.Cell>{commission.name}</Table.Cell>
      <Table.Cell>{commission.global ? 'Si' : 'No '}</Table.Cell>
      <Table.Cell>
        <div>{!commission.global ? commission.roleCount || '-' : <div>-</div>}</div>
      </Table.Cell>
      <Table.Cell>
        <div>{!commission.global ? commission.userCount || '-' : <div>-</div>}</div>
      </Table.Cell>
      <Table.Cell align="right">
        {user && isAuthorizedToHandleCapability(user, EDIT_COMMISSION_PERMISSION) && (
          <>
            <Button onClick={openEditCommissionNameModal}>
              <Icon content="edit" />
            </Button>
            <Button onClick={() => commissionRelationsHandled(commission.id)}>
              <Icon content="arrowRight" />
            </Button>
          </>
        )}
      </Table.Cell>
    </Table.Row>
  );
};
